// Hesap (profil, eSIM'lerim, güvenlik) uç noktaları. Hepsi auth gerektirir;
// Bearer token interceptor tarafından otomatik eklenir.

import api from '../../api/client';
import { unwrap, toApiError } from '../../api/unwrap';

// GET /users/{email} → { id, fullName, email, phone, createdDate }
export const getUser = async (email) => {
  try {
    return await api.get(`/users/${encodeURIComponent(email)}`).then(unwrap);
  } catch (error) {
    throw toApiError(error);
  }
};

// PUT /users → { fullName, phone, email }
export const updateProfile = async ({ email, fullName, phone }) => {
  try {
    await api.put('/users', { fullName, phone, email });
    return true;
  } catch (error) {
    throw toApiError(error);
  }
};

// PUT /users/changePassword → { email, oldPassword, newPassword }
export const changePassword = async ({ email, oldPassword, newPassword }) => {
  try {
    await api.put('/users/changePassword', { email, oldPassword, newPassword });
    return true;
  } catch (error) {
    throw toApiError(error);
  }
};

// POST /users/delete → { email }
export const deleteAccount = async (email) => {
  try {
    await api.post('/users/delete', { email });
    return true;
  } catch (error) {
    throw toApiError(error);
  }
};

// GET /api/app/v2/my-esims?page=&limit= → EsimOrder[]
// V2: aktif/pasif kararı backend'de verilir ve her kayıtta `displayStatus`
// alanı gelir (bkz. src/services/MY_ESIMS_V2_API.md). Client durum türetmez.
export const getMyEsims = async (page = 1, limit = 100) => {
  try {
    const payload = await api
      .get(`/api/app/v2/my-esims?page=${page}&limit=${limit}`)
      .then(unwrap);
    // Zarf açıldıktan sonra ya doğrudan dizi ya da { data, meta } gelebilir.
    if (Array.isArray(payload)) return payload;
    return payload?.data ?? [];
  } catch (error) {
    throw toApiError(error);
  }
};
